import { notEqual } from 'ramda-adjunct';
import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { ScreenProps } from '@components-common/types';
import { useContainer } from '../../../hooks';
import { UIMatch, useLocation, useMatches, useRoutes } from 'react-router-dom';
import { last } from 'ramda';

export type ActiveScreenState = {
  screenId: string;
  screenProps?: ScreenProps;
  screenData?: any;
};

const defaultState: ActiveScreenState = {
  screenId: 'errors_not_found',
  screenProps: undefined,
  screenData: undefined
};

export const ActiveScreenContext = createContext<{
  state: ActiveScreenState;
  setState: React.Dispatch<React.SetStateAction<ActiveScreenState>>;
}>({
  state: defaultState,
  setState: () => null  // Placeholder function
});

const extractCurrentRouteInfo = (matches:UIMatch<unknown, unknown>[],location:any) => {
  //const { matches, location } = state;

  const actualRoute = last(matches);

  if (actualRoute === undefined) {
  console.log("error",'No route found');
    return;
  }
  if (notEqual(actualRoute.pathname, (location as any).pathname)) {
    console.log("warning","Location does not match with matched route");
  }
  const screenId = (actualRoute?.handle as any)?.screenId ? (actualRoute?.handle as any)?.screenId : 'errors_not_found';
  const {
    params,
    pathname,
  } = actualRoute;

  const route = {
    params,
    pathname,
    screenId
  };
  return route;
};
export const useActiveScreen = (

): ScreenProps<any>=> {
  const container = useContainer();
  const activeRoute = useMatches();
  const location = useLocation();
  const extractedRoute = extractCurrentRouteInfo(activeRoute,location);
  if(extractedRoute?.screenId) {
    const { screenId } = extractedRoute!;
    const service = container.resolve<any>("routing-service");
    const route = service.get(screenId);
    return route;
  }
  return undefined as any;
}
